import Cookies from 'js-cookie'
import LocalStorage from "./util.localStorage.js";

const cookies = {}

/**
 * @description 存储 cookie 值
 * @param {String} name cookie name
 * @param {String} value cookie value
 * @param {Object} setting cookie setting
 */
cookies.set = function (name = 'default', value = '', cookieSetting = {}) {
  let currentCookieSetting = {
    expires: 1
  }
  Object.assign(currentCookieSetting, cookieSetting)
  Cookies.set(`rental-${process.env.NODE_ENV}-${name}`, value, currentCookieSetting)
  name === 'uuid' && LocalStorage.set(LocalStorage.keys.uuid, value) // LocalStorageUuid 用于判断 浏览器打开多个系统tab时，是否切换了用户，未切换则优先使用本地缓存

}

/**
 * @description 拿到 cookie 值
 * @param {String} name cookie name
 */
cookies.get = function (name = 'default') {
  return Cookies.get(`rental-${process.env.NODE_ENV}-${name}`)
}

/**
 * @description 拿到 cookie 全部的值
 */
cookies.getAll = function () {
  return Cookies.get()
}

/**
 * @description 删除 cookie
 * @param {String} name cookie name
 */
cookies.remove = function (name = 'default', cookieSetting = {}) {
  Cookies.remove(`rental-${process.env.NODE_ENV}-${name}`, cookieSetting)
}

export default cookies
